// extracted by mini-css-extract-plugin
export var clickableWrapper = "_26-2";
export var placeholderIcon = "_26-3";
export var thumbnailCanvas = "_26-1";
export var thumbnailWrapper = "_26-0";